import { CRITICALITY_LABELS } from "constants/reviewSummary";
import { getStyles } from "utils/getStyles";

const { middleOrange, darkRed, middleBlue, darkestGray, middlePurple } =
  getStyles();

export const GROUP_NAMES = {
  BY_REVIEW_SUMMARY: "By Review Summary",
  BY_COMMENT: "By Comment",
  BY_CHANGE_TYPE: "By change type",
  BY_STATUS: "By status",
};

export const BY_REVIEW_SUMMARY_GROUP = [
  {
    key: "HIGH",
    label: CRITICALITY_LABELS.HIGH,
    countColor: darkRed,
  },
  {
    key: "MEDIUM",
    label: CRITICALITY_LABELS.MEDIUM,
    countColor: middleOrange,
  },
  {
    key: "LOW",
    label: CRITICALITY_LABELS.LOW,
    countColor: middleBlue,
  },
  {
    key: "IGNORE",
    label: CRITICALITY_LABELS.IGNORE,
    countColor: middlePurple,
  },
  {
    key: "UNMARKED",
    label: CRITICALITY_LABELS.UNMARKED,
    countColor: darkestGray,
  },
];

export const BY_COMMENT_GROUP = [{ key: "NOTES", label: "With comments" }];

export const BY_CHANGE_TYPE_GROUP = [
  { key: "MODIFIED", label: "Modified" },
  { key: "ADDED", label: "Added" },
  { key: "DELETED", label: "Deleted" },
  { key: "IDENTICAL", label: "Identical" },
];

export const BY_STATUS_GROUP = [
  { key: "CONFLICTING", label: "Conflicting" },
  { key: "DEFINED", label: "Defined" },
  { key: "NOT DEFINED", label: "Not defined" },
  { key: "REPEATED", label: "Repeated" },
  { key: "USED BEFORE", label: "Used before" },
];
